import {
  EuiCallOut,
  EuiCallOutProps,
  EuiFlexGroup,
  EuiLink,
  EuiSpacer,
  EuiText,
} from "@inscopix/ideas-eui";
import { FlyoutContext } from "providers/FlyoutProvider/FlyoutProvider";
import { ReactNode, useContext } from "react";

type CalloutErrorProps = Pick<EuiCallOutProps, "color" | "title"> & {
  suppressContactSupport?: boolean;
} & (
    | {
        children?: (contactSupport: ReactNode) => ReactNode;
      }
    | {
        message: string;
      }
  );

export const SUPPORT_EMAIL = "support.inscopix@bruker.com";

export const CallOutError = (props: CalloutErrorProps) => {
  const flyoutContext = useContext(FlyoutContext);

  const contactSupport = (() => {
    if (flyoutContext === undefined) {
      return (
        <EuiLink
          href={`mailto:${SUPPORT_EMAIL}?subject=IDEAS%20Support%20Request`}
          target="_blank"
          rel="noopener noreferrer"
        >
          contact support at {SUPPORT_EMAIL}
        </EuiLink>
      );
    } else {
      return (
        <EuiLink onClick={() => flyoutContext.setFlyout("contactSupport")}>
          contact support
        </EuiLink>
      );
    }
  })();

  const content = (() => {
    if ("children" in props && props.children !== undefined) {
      return props.children(contactSupport);
    }
    return (
      <>
        {"message" in props && (
          <>
            <EuiText>{props.message}</EuiText> <EuiSpacer />
          </>
        )}
        {props.suppressContactSupport !== true && (
          <p>
            <EuiFlexGroup alignItems="center" gutterSize="none">
              <EuiText
                size="m"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Please try again later or&nbsp;{contactSupport}
              </EuiText>
            </EuiFlexGroup>
          </p>
        )}
      </>
    );
  })();

  return (
    <EuiCallOut
      title="Sorry, there was an error"
      color="danger"
      iconType="warning"
      {...props}
    >
      {content}
    </EuiCallOut>
  );
};
